import { state } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { State } from 'src/app/enums/state.enum';
import { NewsItemResource } from 'src/app/interfaces/news-item-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { NewsService } from 'src/app/services/news.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
  /**
   * the Columns to be displayed
   */
  displayedColumns = ['number', 'image', 'title', 'source', 'date', 'type', 'state', 'menu'];
  /**
   * The currentpage
   */
  page = null;
  /**
   * The Data to beshown
   */
  dataSource: MatTableDataSource<any>;
  /**
   * THe Form to filter the Events
   */
  filterForm: UntypedFormGroup;
  /**
   * stateoptions
   */
  states = [
    { value: 'NEW', viewValue: 'Neu' },
    { value: 'DRAFT', viewValue: 'Entwurf' },
    { value: 'PUBLISHED', viewValue: 'Veröffentlicht' },
    { value: 'ARCHIVED', viewValue: 'Archiviert' }
  ]
  /**
   * typesoptions
   */
  types = [
    { value: 'NEWS', viewValue: 'Nachrichten' },
   // { value: 'APPOINTMENT', viewValue: 'Veranstaltungen' }
  ]
  /**
   * visibilityoptions
   */
  visibility = [
    { value: 'PUBLIC', viewValue: 'für alle' },
    { value: 'PRIVATE', viewValue: 'für Kunden' },
  ]
  /**
   * The page Metadata
   */
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
/**
 * constructor
 * Init the Form
 * @param news 
 * @param fb 
 * @param overlayService 
 * @param route 
 * @param router 
 */
  constructor(
    private news: NewsService,
    private fb: UntypedFormBuilder,
    private overlayService: OverlayService,
    private route: ActivatedRoute,
    private router: Router) {
    this.filterForm = this.fb.group({
      filterByStates: [],
      filterByTypes: [],
      filterByVisibility: [],
      searchTerm: null
    })
  }
/**
 * ngOnInit
 * Load the News via the Filter set by the URL
 */
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.filterForm.markAllAsTouched();
      this.filterForm.patchValue({
        searchTerm: params?.searchTerm,
        filterByStates: params?.filterByStates?.split(','),
        filterByTypes: params?.filterByTypes?.split(','),
        filterByVisibility: params?.filterByVisibility?.split(',')
      })
      if (params?.page) {
        this.pageData.pageIndex = params?.page;
      }
      if (params?.size) {
        this.pageData.pageSize = params?.size;
      }
    })
    this.news.searchForNews(
      this.pageData.pageIndex,
      this.pageData.pageSize,
      this.filterForm.value.searchTerm,
      this.filterForm.value.filterByStates,
      this.filterForm.value.filterByTypes,
      this.filterForm.value.filterByVisibility).subscribe((news: PagedResources<any>) => {
        this.dataSource = new MatTableDataSource(news.content);
        this.page = news.page;
      })
  }
  /**
   * Load the page of News
   * @param event 
   * @returns 
   */
  loadPage(event?: PageEvent) {
    return this.search(event.pageIndex, event.pageSize);
  }
  /**
   * Search for the News
   * @param pageIndex 
   * @param pageSize 
   */
  search(pageIndex, pageSize) {
    this.news.getNews(pageIndex, pageSize).subscribe((news: PagedResources<any>) => {
      this.dataSource = new MatTableDataSource(news.content);
      this.page = news.page;
      this.pageData.pageIndex = pageIndex;
      this.pageData.pageSize = pageSize;
    })
  }
  /**
   * Get the News based on the Filter
   */
  filterNews() {
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          searchTerm: this.filterForm.value?.searchTerm,
          filterByStates: this.filterForm.value?.filterByStates?.join(),
          filterByTypes: this.filterForm.value?.filterByTypes?.join(),
          filterByVisibility: this.filterForm.value?.filterByVisibility?.join(),
        },
        queryParamsHandling: 'merge'
      }).then(res => {
        console.log(res)
        //set to null if there was an option selected and then deselected to prevent an empty array to be send to the Backend => Error
        if (this.filterForm.value.filterByStates == null) {
          this.filterForm.value.filterByStates = []
        } else if (this.filterForm.value.filterByStates?.length == 0) {
          this.filterForm.value.filterByStates = []
        }
        if (this.filterForm.value.filterByTypes?.length == 0) {
          this.filterForm.value.filterByTypes = null
        }
        if (this.filterForm.value.filterByVisibility?.length == 0) {
          this.filterForm.value.filterByVisibility = null
        }

        this.news.searchForNews(
          this.pageData.pageIndex,
          this.pageData.pageSize,
          this.filterForm.value.searchTerm,
          this.filterForm.value.filterByStates,
          this.filterForm.value.filterByTypes,
          this.filterForm.value.filterByVisibility).subscribe((news: PagedResources<any>) => {
            this.dataSource = new MatTableDataSource(news.content);
            this.page = news.page;
          })
      })
  }
  /**
   * Reset the Filter and load the News without any Filter
   */
  resetFitler() {
    this.filterForm.reset()
    this.filterNews();
  }
  /**
   *  Set the State of the News to PUBLISHED
   * @param element 
   */
  setStateToPublished(element: NewsItemResource) {
    element.state = State.PUBLISHED;
    this.news.editNews(element).subscribe(fromChange => {
      this.overlayService.openSnackBar("Eintrag erfolgreich veröffentlicht");
      this.ngOnInit();
    })
  }
  /**
   * Set the State of the News to ARCHIVED
   * @param element 
   */
  setStateToARCHIVED(element: NewsItemResource) {
    element.state = State.ARCHIVED;
    this.news.editNews(element).subscribe(fromChange => {
      this.overlayService.openSnackBar("Eintrag erfolgreich archiviert")
      this.ngOnInit();
    })
  }
  /**
   * Filter the News if the user presses Enter
   * @param event 
   */
  onKeydown(event) {
    if (event.key === "Enter") {
      this.filterNews()
    }
  }
}
